import React from 'react';
import clsx from 'clsx';

import { IInjectedStylingProps, withStyling } from './higher-order';

import styles from './radio-button.module.scss';

export interface IRadioButtonProps extends IInjectedStylingProps {
	checked?: boolean;
	children: string | React.JSX.Element;
	disabled?: boolean;
	fullWidth?: boolean;
	groupName: string;
	id: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const component = (props: IRadioButtonProps): React.JSX.Element => {
	const fullWidthStyle = props.fullWidth ? { width: '100%' } : { width: 'auto' };
	const radioButtonClassNames = clsx(props.styling?.getStyle(styles, 'radioButton'));

	return (
		<div className={radioButtonClassNames} style={fullWidthStyle}>
			<input
				aria-checked={props.checked}
				checked={props.checked}
				className={props.styling?.getStyle(styles, 'input')}
				disabled={props.disabled}
				id={props.id}
				value={props.id}
				name={props.groupName}
				onChange={props.onChange}
				type="radio"
			/>
			<label className={props.styling?.getStyle(styles, 'label')} htmlFor={props.id} style={fullWidthStyle}>
				{props.children}
			</label>
		</div>
	);
};

const RadioButton = withStyling(component);
export { RadioButton };
